import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import sleep from 'sleep-promise';
import { useKeysStore } from "../../../../core/store/useKeysStore";

function Form() {
    const profileFilter = chooseProfileFilter()
    const { keys } = useKeysStore();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const [form, setForm] = useState();

    const { id } = useParams();

    const path = '/servicecharters/';
    const paths = {
        endpointSave: config.endpoints.backend + 'servicecharters/save',
        endpointGetById: config.endpoints.backend + 'servicecharters/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllProjectUnits: config.endpoints.backend + 'projectunits/getall',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Carta",
        labelTitleEdit: "Editar Carta",
        labelTitleView: 'Visualizar Carta'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'pdc_project_unit_id',
                    type: 'select',
                    label: 'Unidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjectUnits,
                        label: 'no_fantasia',
                        value: 'id',
                        params: {
                            filter: {
                                pdc_project_id: values.pdc_project_id || 'not-list'
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'description',
                    type: 'text',
                    label: 'Descrição',
                    validations: {
                        required: true
                    },
                    maxLength: 255,
                    columnSize: 12
                },
                {
                    name: 'photo',
                    type: 'fileS3',
                    extensionAccept: '.jpeg,.jpg,.png,.ico,.pdf,.xlsx,.docx',
                    limitFileSize: keys?.limitFileSizeDefault,
                    label: 'Foto',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'link',
                    type: 'text',
                    label: 'Link',
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'email',
                    type: 'email',
                    label: 'Email',
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'phone',
                    type: 'phone',
                    label: 'Telefone',
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'address',
                    type: 'address',
                    label: 'Enderaço',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'responsible_name',
                    type: 'text',
                    label: 'Nome do Responsável',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'responsible_role',
                    type: 'text',
                    label: 'Função do Responsável',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'all_time',
                    type: 'select',
                    label: 'Sempre Aberto - 24 horas',
                    options: [
                        { value: '0', label: 'Não' },
                        { value: '1', label: 'Sim' }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);

                        if (values.all_time === '1') {
                            values.time = [];
                        }

                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    }
                },
                values.all_time === '0' ? {
                    name: 'time',
                    type: 'multiinput',
                    label: 'Horário de funcionamento',
                    sortBy: 'index',
                    form: [
                        {
                            label: 'Dia',
                            type: 'select',
                            options: [
                                {
                                    value: 'Segunda-Feira',
                                    label: 'Segunda-Feira'
                                },
                                {
                                    value: 'Terça-Feira',
                                    label: 'Terça-Feira'
                                },
                                {
                                    value: 'Quarta-Feira',
                                    label: 'Quarta-Feira'
                                },
                                {
                                    value: 'Quinta-Feira',
                                    label: 'Quinta-Feira'
                                },
                                {
                                    value: 'Sexta-Feira',
                                    label: 'Sexta-Feira'
                                },
                                {
                                    value: 'Sábado',
                                    label: 'Sábado'
                                },
                                {
                                    value: 'Domingo',
                                    label: 'Domingo'
                                }
                            ],
                            name: 'day',
                            validations: {
                                required: true
                            }
                        },
                        {
                            label: 'De',
                            type: 'time',
                            name: 'from_time',
                            validations: {
                                required: true
                            }
                        },
                        {
                            label: 'Até',
                            type: 'time',
                            name: 'to_time',
                            validations: {
                                required: true
                            }
                        }
                    ],
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'services',
                    type: 'multiinput',
                    label: 'Serviços',
                    sortBy: 'index',
                    form: [
                        {
                            label: 'Serviço',
                            type: 'text',
                            name: 'service',
                            validations: {
                                required: true
                            },
                            maxLength: '255'
                        }
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'procedures',
                    type: 'multiinput',
                    label: 'Procedimentos realizados',
                    sortBy: 'index',
                    form: [
                        {
                            label: 'Procedimento',
                            type: 'text',
                            name: 'service',
                            validations: {
                                required: true
                            },
                            maxLength: '255'
                        }
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }else{
                values.all_time = '0';
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
